import styled from 'styled-components';

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const PaginationSpan = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral.darker};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
`;

export const PaginationButton = styled.button`
  background: #fae8e9;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  border: none;
  cursor: pointer;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.neutral.lightest};
    cursor: default;

    svg {
      fill: ${({ theme }) => theme.colors.neutral.default};
    }
  }

  svg {
    font-size: 24px;
    fill: ${({ theme }) => theme.colors.red.default};
  }
`;
